import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBmpToPngConfig } from '@/data/landingConfig/landingBmpToPngConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BmpToPng } from './schemaObject';

interface Props {}
const BmpToPngConverter: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BmpToPng} />
			<LandingTemplate
				data={landingBmpToPngConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageConverter()}
			/>
		</>
	);
};

export default BmpToPngConverter;
